import { Tooltip } from '@mui/material'
import { PivotPanelTrigger, ToolbarButton } from '@mui/x-data-grid-premium'
import PivotTableChartIcon from '@mui/icons-material/PivotTableChart'

const PivotPanelComponent = () => {
  return (
    <Tooltip title="Pivot">
      <PivotPanelTrigger
        render={(triggerProps, state) => (
          <ToolbarButton {...triggerProps} color={state.active ? 'primary' : 'default'} />
        )}
      >
        <PivotTableChartIcon fontSize="small" />
      </PivotPanelTrigger>
    </Tooltip>
  )
}
export default PivotPanelComponent
